import { ROLES } from '@/constants/roles';
import { authUtils } from '@/utils/auth';

/**
 * Company Owner — the only role that uses Owner home.
 *
 * Bookkeeper does not currently share this landing (they fall through to
 * the sales-rep dashboard). Do not invent a second home or a new role.
 */
export function isCompanyOwner(): boolean {
  const user =
    typeof authUtils.getCurrentUser === 'function'
      ? authUtils.getCurrentUser()
      : null;
  if (user?.isOwner === true) return true;
  if (typeof authUtils.hasRole === 'function') {
    return (
      authUtils.hasRole(ROLES.OWNER.slug) || authUtils.hasRole(ROLES.OWNER.name)
    );
  }
  const roles =
    typeof authUtils.getUserRoles === 'function' ? authUtils.getUserRoles() : [];
  return roles.includes(ROLES.OWNER.slug) || roles.includes(ROLES.OWNER.name);
}
